import type { Message } from 'ai'
import { format } from 'date-fns'

function reduceByDate(acc: Record<string, Message[]>, message: Message) {
  const date = format(new Date(message.createdAt ?? new Date()), 'yyyy-MM-dd')
  if (!acc[date]) {
    acc[date] = []
  }
  acc[date] = [...acc[date], message]
  return acc
}

export function groupMessagesByDate(messages: Message[]): Record<string, Message[]> {
  return messages.filter((message) => message.content).reduce<Record<string, Message[]>>(reduceByDate, {})
}
